import { render, staticRenderFns } from "./TermsOfService.vue?vue&type=template&id=5cac9b1c&"
import script from "./TermsOfService.vue?vue&type=script&lang=ts&"
export * from "./TermsOfService.vue?vue&type=script&lang=ts&"
import style0 from "./TermsOfService.vue?vue&type=style&index=0&id=5cac9b1c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QPage from 'quasar/src/components/page/QPage.js';
import QColor from 'quasar/src/components/color/QColor.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QPage,QColor});
